import { gql } from 'apollo-angular';

const UPDATE_USER_STATUS = gql`
  mutation activateUser($userId: Long!, $activateUser: Boolean!) {
    activateUser(
      activateUserRequest: { userId: $userId, activateUser: $activateUser }
    ) {
      id
    }
  }
`;

export default UPDATE_USER_STATUS;
